<template>
<AppDialog :is-open="isDialogOpened"
           :okText="$t('common.app-file-upload.CancelAllFilesDialog.confirmText')"
           :cancelText="$t('common.app-file-upload.CancelAllFilesDialog.cancelText')"
           @ok="onOk"
           @cancel="closeDialog"
>
  <template #title>{{ $t('common.app-file-upload.CancelAllFilesDialog.title') }}</template>
  <template #body>{{ $t('common.app-file-upload.CancelAllFilesDialog.text') }}</template>
</AppDialog>
</template>

<script>
import { mapActions } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'
import { AppUploadHandlerActionTypes } from '@/store/modules/app-upload-handler/action_types'

export default {
  name: 'CancelAllFilesDialog',
  components: { AppDialog },
  mixins: [dialogMixin],
  methods: {
    ...mapActions('appUploadHandler', [AppUploadHandlerActionTypes.CANCEL_ALL]),
    onOk () {
      this.CANCEL_ALL()
      this.closeDialog()
    },
  },
}
</script>
